import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';
import { hostOf } from './webAddress';

export interface ExternalLinkProps {
  href: string;
  children: ReactNode;
  className?: string;
}

/**
 * A link out of the app: new tab, no hand-back to the opener, the host on hover.
 *
 * One component for every address that leaves the app — rendered markdown, a run's
 * result links (spec 095), anything later — so the safety attributes are written
 * once and a link can never be "the one that forgot `noopener`". Callers gate with
 * `isWebAddress` (the markdown renderer does; so will the results tab): this
 * renders whatever it is given.
 */
export function ExternalLink({ href, children, className }: ExternalLinkProps) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title={hostOf(href)}
      className={cn(
        'text-primary underline underline-offset-2 [overflow-wrap:anywhere]',
        'focus-visible:ring-ring rounded-sm focus-visible:ring-3 focus-visible:outline-none',
        className,
      )}
    >
      {children}
    </a>
  );
}
